const SESSION_EXPIRED_PATTERN = /세션이 유효하지 않/;

export const SESSION_EXPIRED_UI_MESSAGE =
  '오랫동안 사용하지 않아 세션이 만료되었습니다. 새로고침 후 다시 시도해 주세요.';

export const isSessionExpiredMessage = (text: string): boolean =>
  SESSION_EXPIRED_PATTERN.test(text);

export const isSessionExpiredResponse = async (
  response: Response,
): Promise<boolean> => {
  if (response.status !== 401) {
    return false;
  }
  try {
    const body = (await response.clone().json()) as { detail?: string };
    return (
      typeof body.detail === 'string' && isSessionExpiredMessage(body.detail)
    );
  } catch {
    return false;
  }
};

type SessionExpiredListener = () => void;
const listeners = new Set<SessionExpiredListener>();
let hasTriggered = false;

export const subscribeSessionExpired = (
  listener: SessionExpiredListener,
): (() => void) => {
  listeners.add(listener);
  return () => listeners.delete(listener);
};

export const triggerSessionExpired = (): void => {
  if (hasTriggered) {
    return;
  }
  hasTriggered = true;
  listeners.forEach((listener) => listener());
};
